import safeFetch from '../utils/safeFetch';

export async function post<TResponse, TPayload = unknown>(
  url: string | URL,
  payload?: TPayload,
): Promise<TResponse> {
  const response = await safeFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: payload === undefined ? undefined : JSON.stringify(payload),
  });

  return response.json() as Promise<TResponse>;
}
